export default __webpack_public_path__ + "static/media/beverages.994dd7a5.jpg";